/**
 * T054: usePrompt Hook
 * Query hook for fetching a single prompt by ID
 */

import { useQuery } from '@tanstack/react-query'
import { getPrompt } from '@/services/prompts'
import { queryKeys } from '@/lib/query-keys'

export function usePrompt(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.prompts.detail(id!),
    queryFn: () => getPrompt(id!),
    enabled: !!id,
  })
}
